export default [{
  path: '/admin/apply/diy/homeIndex',
  name: 'homeIndex',
  component: () => import('@/views/apply/diy/homeIndex'),
  meta: {
    title: 'DIY页面',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/diy/addDiyPage',
  name: 'addDiyPage',
  component: () => import('@/views/apply/diy/addDiyPage'),
  meta: {
    title: 'DIY装修',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/diy/btoNavigation',
  name: 'btoNavigation',
  component: () => import('@/views/apply/diy/btoNavigation'),
  meta: {
    title: '底部导航',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/diy/addBtoNavigation',
  name: 'addBtoNavigation',
  component: () => import('@/views/apply/diy/addBtoNavigation'),
  meta: {
    title: '添加底部导航',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/diy.js